import { styled } from "@pigment-css/react";
import { SortDirection } from "../types";

const SortIconContainer = styled("span")({
  display: "inline-flex",
  flexDirection: "column",
  marginLeft: "6px",
  verticalAlign: "middle",
  width: "8px",
  height: "13px",
  gap: "3px",
});

interface SortIconProps {
  direction: SortDirection;
  isActive: boolean;
}

export const SortIcon = ({ direction, isActive }: SortIconProps) => {
  return (
    <SortIconContainer style={{ visibility: isActive ? "visible" : "hidden" }}>
      {/* Up triangle - highlighted when ascending */}
      <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.175781 3.19141L3.06641 0.234375C3.22005 0.078125 3.39193 0 3.58203 0C3.67839 0.00260417 3.76823 0.0234375 3.85156 0.0625C3.9349 0.0989583 4.01562 0.15625 4.09375 0.234375L6.98047 3.19141C7.09766 3.30599 7.15625 3.44922 7.15625 3.62109C7.15625 3.73828 7.1276 3.84375 7.07031 3.9375C7.01562 4.03125 6.94141 4.10677 6.84766 4.16406C6.75391 4.22135 6.64974 4.25 6.53516 4.25C6.35807 4.25 6.20573 4.18359 6.07812 4.05078L3.42578 1.3125H3.74219L1.08203 4.05078C0.951823 4.18359 0.798177 4.25 0.621094 4.25C0.50651 4.25 0.402344 4.22135 0.308594 4.16406C0.214844 4.10677 0.139323 4.03125 0.0820312 3.9375C0.0273438 3.84375 0 3.73828 0 3.62109C0 3.53776 0.0143229 3.45964 0.0429688 3.38672C0.0742188 3.3138 0.11849 3.2487 0.175781 3.19141Z"
          fill="#131313"
          fillOpacity={direction === "asc" ? "0.56" : "0.24"}
        />
      </svg>
      {/* Down triangle - highlighted when descending */}
      <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.58203 4.24609C3.39453 4.24609 3.22266 4.16927 3.06641 4.01562L0.175781 1.05859C0.11849 0.998698 0.0742188 0.933594 0.0429688 0.863281C0.0143229 0.790365 0 0.71224 0 0.628906C0 0.511719 0.0273438 0.40625 0.0820312 0.3125C0.139323 0.216146 0.214844 0.140625 0.308594 0.0859375C0.402344 0.0286458 0.50651 0 0.621094 0C0.795573 0 0.949219 0.0664062 1.08203 0.199219L3.74219 2.9375H3.42578L6.07812 0.199219C6.21094 0.0664062 6.36328 0 6.53516 0C6.64974 0 6.75391 0.0286458 6.84766 0.0859375C6.94141 0.140625 7.01562 0.216146 7.07031 0.3125C7.1276 0.40625 7.15625 0.511719 7.15625 0.628906C7.15625 0.798177 7.09766 0.941406 6.98047 1.05859L4.09375 4.01562C4.01562 4.09375 3.9349 4.15104 3.85156 4.1875C3.76823 4.22396 3.67839 4.24349 3.58203 4.24609Z"
          fill="#131313"
          fillOpacity={direction === "desc" ? "0.56" : "0.24"}
        />
      </svg>
    </SortIconContainer>
  );
};
